import type { IzQuestion } from '../../question-bank/izteach';
import { getIzteachClient } from '../clients';
import { pinParams } from '../core/pinParams';
import { Repository } from '../core/repository';
import { libraryVendorId } from '../session';

// Question bank works on content tenant, not session's; examination-service trusts vendorId from query/body without checking token
export function bankVendorId(): string {
  return libraryVendorId();
}

const bank = () => ({ vendorId: bankVendorId() });

/** /question: count, create, update, delete. */
export const questionRows = pinParams(Repository<IzQuestion>(getIzteachClient('exam'), '/question'), bank);

/** /question/admin: the reads, because plain GET /question strips `correct`. */
export const adminQuestionRows = pinParams(Repository<IzQuestion>(getIzteachClient('exam'), '/question/admin'), bank);
